import React, { useEffect, useState } from "react";
import Modal from "../../resources/js/Modal.js"; // 모달 컴포넌트 가져오기
import "../../resources/css/common.css";
import "../../resources/css/layout.css";

const Footer = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 700);
  const [visible, setVisible] = useState(false);
  const [isRequest, setIsRequest] = useState(false);
  const [isStart, setIsStart] = useState(false);
  const [phoneNum, setPhoneNum] = useState(""); // 상태 추가
  const [phoneErrorMessage, setPhoneErrorMessage] = useState("");

  const [sidoList, setSidoList] = useState([]);
  const [gunguList, setGunguList] = useState([]);
  const [sido, setSido] = useState(""); // 상태 훅 정의

  const [isOpen, setIsOpen] = useState(false);

  const [isChecked, setIsChecked] = useState(false);

  const [zipcode, setZipcode] = useState("");
  const [gungu, setGungu] = useState("");

  useEffect(() => {
    const fetchSidoList = async () => {
      try {
        const response = await fetch("/adress/sido");
        const result = await response.json();
        setSidoList(result);
      } catch (error) {
        console.error("Error fetching sido list:", error);
      }
    };

    fetchSidoList();
  }, []);

  const handleSidoChange = async (event) => {
    const selectedSido = event.target.value;
    console.log("Selected Sido:", selectedSido);
    setSido(selectedSido);

    try {
      const response = await fetch(`/adress/gungu?sido=${selectedSido}`);
      console.log("Fetch URL:", `/adress/gungu?sido=${selectedSido}`); // 추가된 로그
      const result = await response.json();
      console.log(result); // API 응답 확인

      // sigunguName만 추출하여 gunguList에 저장
      const sigunguNames = result.map((gungu) => gungu.sigunguName);
      console.log("Sigungu Names:", sigunguNames); // 추출된 시군구 이름 확인
      setGunguList(sigunguNames);
    } catch (error) {
      console.error("Error fetching gungu list:", error);
      setGunguList([]);
    }
  };

  const handleGunguChange = (event) => {
    const selectedGungu = event.target.value;
    setGungu(selectedGungu);
  };

  useEffect(() => {}, [gunguList]); // gunguList가 변경될 때마다 로그 찍기

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Resize handler
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 700);
  };

  // Toggle request form visibility
  const handleRequestToggle = () => {
    setIsRequest(!isRequest);
    setIsStart(false);
    setVisible(true);
  };

  const handleStartToggle = () => {
    setIsStart(!isStart);
    setIsRequest(false);
    setVisible(true);
  };

  const handleOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  // ************************************** 전화번호 ******************************************************//

  // Handle phone number input change
  const handlePhoneNumChange = (event) => {
    const newValue = event.target.value.replace(/[^0-9]/g, "");
    if (newValue.length <= 11) {
      setPhoneNum(newValue);
    }
    validatePhoneNumber(newValue);
  };

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^(010|)\d{8}$/;
    if (!phoneRegex.test(number)) {
      setPhoneErrorMessage("올바른 전화번호 형식이 아닙니다.(010만 가능)");
    } else {
      setPhoneErrorMessage("");
    }
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const handleSubmit = async (event, formType) => {
    event.preventDefault();

    console.log("폼 타입:", formType);

    const name = event.target.name.value;
    if (!name) {
      alert("이름은 필수 입력항목입니다.");
      return;
    }

    const cell = event.target.cell.value;
    if (!cell) {
      alert("휴대폰번호는 필수 입력항목입니다.");
      return;
    }

    if (formType === "request") {
      const baby_age = event.target.baby_age.value;
      if (!baby_age) {
        alert("자녀나이는 필수 입력항목입니다.");
        return;
      }

      const addr1 = event.target.addr1.value;
      if (!addr1) {
        alert("주소는 필수 입력항목입니다.");
        return;
      }

      const addr2 = event.target.addr2.value;
      if (!addr2) {
        alert("상세주소는 필수 입력항목입니다.");
        return;
      }
    }

    if (formType === "start") {
      const sub_gubun = event.target.sub_gubun.value;
      if (!sub_gubun) {
        alert("교육원 형태는 필수 선택항목입니다.");
        return;
      }

      const sido = event.target.sido.value;
      if (!sido) {
        alert("시도는 필수 선택항목입니다.");
        return;
      }

      if (!gungu && sido !== "세종특별자치시") {
        alert("시군구는 필수 선택항목입니다.");
        return;
      }

      const asobiRoot = event.target.asobiRoot.value;
      if (!asobiRoot) {
        alert("유입경로는 필수 선택사항입니다.");
        return; // 이 부분에서 return
      }
    }

    if (phoneErrorMessage) {
      alert("올바른 전화번호 형식이 아닙니다.(010만 가능)");
      return;
    }

    if (!isChecked) {
      alert("개인정보 수집 및 활용에 동의해 주세요.");
      return;
    }

    // 신청 정보 확인
    const confirmation = window.confirm(`입력하신 정보로 신청하시겠습니까?`);

    if (!confirmation) {
      return; // 사용자가 취소하면 아무 작업도 하지 않음
    }

    const formData = new FormData(event.target);
    console.log([...formData]);

    if (formType === "start") {
      formData.set("gubun", "BB01");
    } else if (formType === "request") {
      formData.set("gubun", "BB04");
    }

    try {
      const response = await fetch("/asobiForm", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      alert("신청이 완료되었습니다."); // 성공 메시지
      console.log("응답:", result);
      window.location.reload();
    } catch (error) {
      console.error("에러 발생:", error);
      alert("신청 중 에러가 발생했습니다.");
    }
  };

  // ********************************************************************************************//

  // Set up event listener for window resize
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize); // Cleanup
  }, []);

  // *************************************** 주소 API *****************************************************//

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    script.async = true;
    script.onload = () => {
      // Postcode API가 로드된 후에 사용할 수 있습니다.
    };
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script); // Clean up script on unmount
    };
  }, []);

  const getDaumPostcode = () => {
    new window.daum.Postcode({
      oncomplete: function (data) {
        let addr = "";
        if (data.userSelectedType === "R") {
          addr = data.roadAddress;
        } else {
          addr = data.jibunAddress;
        }

        let extraAddr = "";
        if (data.userSelectedType === "R") {
          if (data.bname !== "" && /[동|로|가]$/g.test(data.bname)) {
            extraAddr += data.bname;
          }
          if (data.buildingName !== "" && data.apartment === "Y") {
            extraAddr +=
              extraAddr !== "" ? ", " + data.buildingName : data.buildingName;
          }
          if (extraAddr !== "") {
            extraAddr = " (" + extraAddr + ")";
          }
        }

        // 요소 ID 확인
        const zipcodeField = document.getElementById("zipcode");
        const addr1Field = document.getElementById("addr1");
        const addr2Field = document.getElementById("addr2");
        const sidoField = document.getElementById("sido_i");
        const gunguField = document.getElementById("gungu_i");

        // 요소가 존재할 때만 값을 설정
        if (addr1Field) {
          addr1Field.value = addr + extraAddr;
        }
        if (zipcodeField) {
          setZipcode(data.zonecode);
          zipcodeField.value = data.zonecode;
          console.log("Zipcode:", zipcodeField.value);
        }
        if (addr2Field) {
          addr2Field.focus();
        }
        if (sidoField) {
          setSido(data.sido);
          sidoField.value = data.sido;
          console.log("Sido:", sidoField.value);
        }
        if (gunguField) {
          setGungu(data.sigungu);
          gunguField.value = data.sigungu;
          console.log("Gungu:", gunguField.value);
        }
      },
    }).open();
  };
  // ********************************************************************************************//

  return (
    <footer id="footer">
      <div className="fnb">
        <div className="wrap">
          {/* Customer Service Section */}
          <div className="desc cs">
            <div className="title">아소비 고객센터</div>
            <div className="cont">
              <div className="tit">아소비 창업 및 입회 문의</div>
              <div className="tel">1688-1993</div>
              <div className="txt">
                평일 : 오전 9시 30분 ~ 오후 6시 <br /> 주말/공휴일 : 휴무
              </div>
            </div>
          </div>

          {/* App Download Section */}
          <div className="desc app">
            <div className="title">아소비 앱 다운로드</div>
            <div className="cont">
              <div className="down">
                <img src="/custom-resources/img/app_logo.png" alt="App Logo" />
                <a href="/app">모바일 앱 다운받기</a>
              </div>
            </div>
          </div>

          {/* Social Media Links */}
          <div className="desc sns">
            <div className="title">아소비를 만나는 또 다른 공간</div>
            <div className="cont">
              <ul>
                <li>
                  <a
                    href="https://www.youtube.com/c/%EC%95%84%EC%86%8C%EB%B9%84"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/custom-resources/img/social_youtube.png"
                      alt="YouTube"
                    />
                    <p>유튜브</p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.instagram.com/asobieducation/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/custom-resources/img/social_instagram.png"
                      alt="Instagram"
                    />
                    <p>인스타</p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://blog.naver.com/asobieducation"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/custom-resources/img/social_blog.png" alt="Blog" />
                    <p>블로그</p>
                  </a>
                </li>
                <li>
                  <a
                    href="https://cafe.naver.com/asobe"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src="/custom-resources/img/social_cafe.png" alt="Cafe" />
                    <p>카페</p>
                  </a>
                </li>
              </ul>
            </div>
            <div id="top">
              <button type="button" onClick={scrollToTop}>
                <i></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="footer">
        <div className="wrap">
          <div className="logo">
            <img src="/custom-resources/img/fogo.png" alt="Logo" />
          </div>
          <div className="addr">
            <div className="link">
              <a href="/company">회사 소개</a>
              <a href="/startUp">창업 안내</a>
              <a href="/terms">이용약관</a>
              <a href="/policy">개인정보처리방침</a>
              <a href="/email">이메일무단수집거부</a>
            </div>
            <div className="info">
              <span>
                서울시 은평구 증산로 337(증산동, 아소비빌딩) ㈜아소비교육 ,
                대표자 : 박시연
              </span>
              <span>
                사업자번호 : 105-87-49901, 대표전화 : 1688-1993, 팩스(fax) :
                02-335-4410
              </span>
            </div>
            <div className="cite">
              Copyright ⓒ ASOBI EDUCATION All Rights Reserved.
            </div>
          </div>
        </div>
      </div>

      <div
        id="fixed-footer"
        className={`fixed-footer ${isMobile ? "fixed-mo" : "fixed-pc"}`}
      >
        <div className="fix-form">
          <div
            className={`side-request-${isRequest ? "on" : "off"} sidebtn`}
            onClick={handleRequestToggle}
          >
            학습
            <br />
            상담
            <br />
            <span>{isRequest ? "→" : "←"}</span>
          </div>
          <div
            className={`side-start-${isStart ? "on" : "off"} sidebtn`}
            onClick={handleStartToggle}
          >
            창업
            <br />
            상담
            <br />
            <span>{isStart ? "→" : "←"}</span>
          </div>

          {visible && (
            <div
              className={`fix-form-box ${
                isRequest || isStart ? "show" : "hide"
              }`}
            >
              {/* Start Inquiry Form */}
              {isStart && (
                <div className="form startup-form show">
                  <div className="wrap">
                    <h3>아소비 창업 문의</h3>
                    <p className="fix-num">1688-1993</p>
                    <form
                      name="writeform1"
                      onSubmit={(e) => handleSubmit(e, "start")}
                    >
                      <div className="input">
                        <input type="hidden" name="gubun" value="BB01" />
                        <input type="text" name="name" placeholder="이름" />
                        <input
                          type="tel"
                          name="cell"
                          placeholder="휴대폰번호"
                          maxLength="11"
                          value={phoneNum}
                          onChange={handlePhoneNumChange}
                        />
                        <select name="sub_gubun">
                          <option value="">교육원 형태</option>
                          <option value="A">공부방형</option>
                          <option value="B">학원형</option>
                        </select>
                        <select name="sido" onChange={handleSidoChange}>
                          <option value="">시도선택</option>
                          {sidoList.map((sido) => (
                            <option
                              key={sido.sigunguCode}
                              value={sido.sidoName}
                            >
                              {sido.sidoName}
                            </option>
                          ))}
                        </select>
                        <input type="hidden" name="addr1" value={sido} />
                        <select name="gungu" onChange={handleGunguChange}>
                          <option value="">시군구</option>
                          {gunguList.length > 0 ? (
                            gunguList.map((gungu, index) => (
                              <option key={index} value={gungu}>
                                {gungu} {/* 여기서 gungu는 문자열입니다 */}
                              </option>
                            ))
                          ) : (
                            <option value="">시군구가 없습니다.</option>
                          )}
                        </select>
                        <input type="hidden" name="addr2" value={gungu} />
                        <select
                          name="asobiRoot"
                          id="asobiRoot"
                          className="required1"
                        >
                          <option value="">유입경로</option>
                          <option value="인터넷 검색">인터넷 검색</option>
                          <option value="온라인 광고">온라인 광고</option>
                          <option value="인근 아소비">인근 아소비</option>
                          <option value="인쇄 홍보물">인쇄 홍보물</option>
                          <option value="지인 소개">지인 소개</option>
                          <option value="공식 카페">공식 카페</option>
                          <option value="맘카페">맘카페</option>
                          <option value="기타">기타</option>
                        </select>
                        <div className="check">
                          <label className="checkbox">
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            />
                            <span>
                              개인정보 수집 및 활용동의
                              <button
                                onClick={(event) => {
                                  event.preventDefault(); // 폼 제출 기본 동작 방지
                                  handleOpen(); // 모달 열기
                                }}
                                id="popTermsRequest"
                                style={{
                                  width: "auto",
                                  height: "auto",
                                  background: "none",
                                  fontSize: "13px",
                                  marginTop: "0px",
                                  marginLeft: "10px",
                                }}
                              >
                                [내용 보기]
                              </button>
                            </span>
                          </label>
                        </div>
                        <button type="submit">신청</button>
                      </div>
                    </form>
                    <div className="popupTerms">
                      <Modal isOpen={isOpen} onClose={handleClose}>
                        <div className="content">
                          - 수집목적 : 서비스 제공을 위한 이용자 식별 및 본인
                          여부 확인, 계약 이행을 위한 연락, 민원등 고객 고충
                          처리
                          <br />
                          - 수집항목 : 신청자명, 휴대폰 번호, 자녀 나이, 주소
                          <br />
                          - 보유기간 : 작성 후 1년 이내
                          <br />
                          ※ 학습 상담을 진행하기 위하여 ㈜아소비교육에서 전화
                          연락을 드리고 있습니다.
                          <br />※ 서비스 제공을 위해서 필요한 최소한의
                          개인정보이므로 동의를 해주셔야 서비스를 이용하실 수
                          있습니다.
                        </div>
                      </Modal>
                    </div>
                  </div>
                </div>
              )}

              {/* Request Inquiry Form */}
              {isRequest && (
                <div className="form request-form show">
                  <div className="wrap">
                    <h3>아소비 학습 상담 문의</h3>
                    <p className="fix-num">1688-1993</p>
                    <form
                      name="writeform2"
                      onSubmit={(e) => handleSubmit(e, "request")}
                    >
                      <div className="input">
                        <input type="hidden" name="gubun" value="BB04" />
                        <input type="text" name="name" placeholder="자녀이름" />
                        <input
                          type="tel"
                          name="cell"
                          placeholder="휴대폰번호"
                          maxLength="11"
                          value={phoneNum}
                          onChange={handlePhoneNumChange}
                        />
                        <select name="baby_age">
                          <option value="">자녀나이</option>
                          <option value="5">5</option>
                          <option value="6">6</option>
                          <option value="7">7</option>
                          <option value="8">8</option>
                          <option value="9">9</option>
                          <option value="10">10</option>
                        </select>
                        <input
                          type="text"
                          id="addr1"
                          name="addr1"
                          placeholder="주소"
                          onClick={getDaumPostcode}
                        />
                        <input
                          type="text"
                          id="addr2"
                          name="addr2"
                          placeholder="상세주소"
                        />
                        <input
                          type="hidden"
                          name="sido"
                          id="sido_i"
                          value={sido}
                        />
                        <input
                          type="hidden"
                          name="gungu"
                          id="gungu_i"
                          value={gungu}
                        />
                        <input
                          type="hidden"
                          name="zipcode"
                          id="zipcode"
                          value={zipcode}
                        />
                        <div className="check">
                          <label className="checkbox">
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={handleCheckboxChange}
                            />
                            <span>
                              개인정보 수집 및 활용동의
                              <button
                                onClick={(event) => {
                                  event.preventDefault(); // 폼 제출 기본 동작 방지
                                  handleOpen(); // 모달 열기
                                }}
                                id="popTermsRequest"
                                style={{
                                  width: "auto",
                                  height: "auto",
                                  background: "none",
                                  fontSize: "13px",
                                  marginTop: "0px",
                                  marginLeft: "10px",
                                }}
                              >
                                [내용 보기]
                              </button>
                            </span>
                          </label>
                        </div>
                        <button type="submit">신청</button>
                      </div>
                    </form>
                    <div className="popupTerms">
                      <Modal isOpen={isOpen} onClose={handleClose}>
                        <div className="content">
                          - 수집목적 : 서비스 제공을 위한 이용자 식별 및 본인
                          여부 확인, 계약 이행을 위한 연락, 민원등 고객 고충
                          처리
                          <br />
                          - 수집항목 : 신청자명, 휴대폰 번호, 자녀 나이, 주소
                          <br />
                          - 보유기간 : 작성 후 1년 이내
                          <br />
                          ※ 학습 상담을 진행하기 위하여 ㈜아소비교육에서 전화
                          연락을 드리고 있습니다.
                          <br />※ 서비스 제공을 위해서 필요한 최소한의
                          개인정보이므로 동의를 해주셔야 서비스를 이용하실 수
                          있습니다.
                        </div>
                      </Modal>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
